"use client"

import { useState } from "react"

export default function Calendar() {
    const [currentDate] = useState(new Date(2024, 8, 8)) // September 8, 2024

    const renderCalendar = () => {
        const year = currentDate.getFullYear()
        const month = currentDate.getMonth()

        const firstDayOfMonth = new Date(year, month, 1).getDay()
        const daysInMonth = new Date(year, month + 1, 0).getDate()

        const weeks = []
        let days = []

        for (let i = 0; i < firstDayOfMonth; i++) {
            days.push(<td key={`empty-${i}`} className="calendar-cell"></td>)
        }

        for (let day = 1; day <= daysInMonth; day++) {
            const isHighlighted = day === 8

            days.push(
                <td key={day} className="calendar-cell text-center relative">
                    {isHighlighted ? (
                        <div className="highlight-wrapper">
                            <svg
                                viewBox="0 0 15 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                <g
                                    id="SVGRepo_tracerCarrier"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                ></g>
                                <g id="SVGRepo_iconCarrier">
                                    {" "}
                                    <path
                                        d="M4.03553 1C1.80677 1 0 2.80677 0 5.03553C0 6.10582 0.42517 7.13228 1.18198 7.88909L7.14645 13.8536C7.34171 14.0488 7.65829 14.0488 7.85355 13.8536L13.818 7.88909C14.5748 7.13228 15 6.10582 15 5.03553C15 2.80677 13.1932 1 10.9645 1C9.89418 1 8.86772 1.42517 8.11091 2.18198L7.5 2.79289L6.88909 2.18198C6.13228 1.42517 5.10582 1 4.03553 1Z"
                                        fill="#C8A898"
                                    ></path>{" "}
                                </g>
                            </svg>
                            <span className="highlighted-day">{day}</span>
                        </div>
                    ) : (
                        <span>{day}</span>
                    )}
                </td>,
            )

            if ((firstDayOfMonth + day) % 7 === 0) {
                weeks.push(<tr key={`week-${weeks.length}`}>{days}</tr>)
                days = []
            }
        }

        if (days.length > 0) {
            weeks.push(<tr key={`week-${weeks.length}`}>{days}</tr>)
        }

        return weeks
    }

    const formatMonth = (date: Date) => {
        return date.toLocaleDateString("en-US", { month: "long" }).toUpperCase()
    }

    const formatDate = (date: Date) => {
        return date
            .toLocaleDateString("en-US", {
                month: "long",
                day: "2-digit",
                year: "numeric",
            })
            .toUpperCase()
    }

    const daysOfWeek = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"]

    return (
        <div className="calendar-container">
            <div className="calendar-card">
                <div className="calendar-header">
                    <h2 className="fontJost">{formatDate(currentDate)}</h2>
                </div>

                <table className="calendar-table">
                    <thead>
                        <tr>
                            {daysOfWeek.map((day) => (
                                <th key={day} className="calendar-header-cell">
                                    {day}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>{renderCalendar()}</tbody>
                </table>
            </div>
        </div>
    )
}
